
import React, { useState, useEffect } from 'react';
import { BASE_URL, instanceAxios, convertDateStr } from "../../config";
import { toast } from "react-toastify";

export default function CommentList(props) {
    const [ShowDataComment, SetShowDataComment] = useState([]);   
    const [totalRecord, SettotalRecord] = useState(0);
    const GetListData = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/Comment.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'GetListAll',
                ParentId: props.selectItemId
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {                   
                    SetShowDataComment(response.data);
                    SettotalRecord(response.data.length);
                }
                else
                    SetShowDataComment([]);
            })
            .catch((err) => {

            })
    }
    const SavetApproval_Status = (Id,value) => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/Comment.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'Update',               
                Approval_Status: value,
                Id: Id
            })
        };
        instanceAxios(config)
            .then(function (response) {
                GetListData();
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })
    }  
    useEffect(() => {
        GetListData();       
    }, [props.selectItemId])
    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-xs-12">
                <div className="box" style={{ borderBottom: "5px solid #b8bec8" }}>
                    <div className="box-header" style={{ borderBottom: "3px solid #b8bec8" }}>
                        <h3 className="box-title"> فهرست کامنت های موضوع : <span style={{color:"orangered"}}>{props.subject}</span></h3>

                        <div className="box-tools">
                            <div className=" pull-left" style={{ display: 'inline-flex' }}>
                                <div style={{ marginLeft: '10px', marginTop: "auto" }} ><span style={{ color: "orange" }} title="تعداد کل رکوردها">{totalRecord}</span></div>
                                <div className="btn-group">
                                    <button type="button" onClick={(e) => props.onSetshowlist(0, '')} title="بازگشت" className="btn btn-default btn-sm" style={{ fontSize: "18px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-reply-all" ></i></button>
                                    <button type="button" onClick={(e) => GetListData()} className="btn btn-default btn-sm" style={{ fontSize: "16px", backgroundColor: "#e6dcdc", marginLeft: "3px" }}><i className="icon ion-refresh"></i></button>                                    
                                </div>

                            </div>
                            <div className="input-group input-group-sm" style={{ width: "150px", marginLeft: "60px" }}>
                                <input type="text" name="table_search" className="form-control pull-right" placeholder="جستجو" />

                                <div className="input-group-btn" >
                                    <button type="submit" style={{ backgroundColor: "#e3dcdc" }} className="btn btn-default"><i className="fa fa-search"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="box-body table-responsive " style={{ minHeight: "500px" }}>
                        <table className="table table-hover" >
                            <tr style={{ borderTop: "0px solid currentColor", lineHeight: "45px", backgroundColor:"#f2f29987"}}>
                                <th>ردیف</th>
                                <th>نام و نام حانوادگی </th>
                                <th>تاریخ</th>
                                <th style={{ width: "50vw" }}>متن نظر</th>                               
                                <th style={{ fontSize: "12px" }}>تایید</th>                               
                                <th style={{ fontSize: "12px" }}>عدم تایید</th>
                            </tr>
                            {
                                ShowDataComment !== null && ShowDataComment.length != 0 ?
                                    ShowDataComment.map((item, i) => {
                                        return <tr key={i} style={{ verticalAlign: "top", borderTop: "1px solid currentColor", lineHeight: "40px", backgroundColor: i % 2 === 0 ? "rgba(218, 232, 236, 0.51)" :"#ddeebe82" }}>
                                            <td style={{ width: "40px",textAlign:"center" }} scope="row">{(i + 1)}</td>
                                            <td>{item.Familly}</td>
                                            <td>{convertDateStr(new Date(item.DateComment) / 1000, true)}</td>
                                            <td style={{ width: "30vw" }}>{item.Comment}</td>
                                            
                                            <td >
                                                <i className={item.Approval_Status === 1 ? "icon ion-ios-checkmark" : "icon ion-ios-circle-outline"}
                                                    style={{ fontSize: "22px", color: "rgb(25, 172, 69)", cursor: "pointer", marginLeft: "15px" }}
                                                    onClick={(e) => SavetApproval_Status(item.Id,"1")}
                                                ></i>
                                            </td>
                                            <td >
                                                <i className={item.Approval_Status === 2 ? "icon ion-ios-checkmark" : "icon ion-ios-circle-outline"}
                                                    style={{ fontSize: "22px", color: "rgb(204, 32, 32)", cursor: "pointer", marginLeft: "15px" }}
                                                    onClick={(e) => SavetApproval_Status(item.Id, "2")}
                                                ></i>
                                            </td>
                                        </tr>
                                    })
                                    : <tr style={{ borderTop: "0px solid currentColor", lineHeight: "200px", textAlign: "center", color: "#ac5252" }}><td colSpan={10} ><h4> نظری ثبت نشده است</h4>
                                    </td></tr>
                            }

                        </table>
                    </div>

                </div>

            </div>
        </div>

    );
}